// PROTOTYPE — deckbuilder agent. Throwaway code, see
// apps/server/app/agents/deckbuilder/NOTES.md.
import { Suspense, lazy } from 'react'
import { UserProfileRole } from '@breakoutlearning/firebase-repository/types'
import { inDevelopmentOrPreview } from 'config/environment'
import { RoleGuard } from 'config/RoleGuard'
import { DeckbuilderLoader } from './DeckbuilderLoader'

// Its own chunk: the AI SDK and the meeting preview load only on these pages.
// eslint-disable-next-line react-refresh/only-export-components
const DeckbuilderPage = lazy(() =>
  import('./DeckbuilderPage').then((m) => ({ default: m.DeckbuilderPage }))
)

// Called from config/routes.tsx with its addTwoColumnRoute. Staging, preview
// builds and local only for now: production and beta never register the
// pages (the server answers 404 there too). Same roles as the deck editor.
export function registerDeckbuilderRoutes(
  addTwoColumnRoute: (
    name: string,
    path: string,
    component: JSX.Element
  ) => void
) {
  if (!inDevelopmentOrPreview()) return

  const page = (
    <RoleGuard
      roles={[
        UserProfileRole.admin,
        UserProfileRole.author,
        UserProfileRole.editor,
      ]}
    >
      <Suspense fallback={<DeckbuilderLoader />}>
        <DeckbuilderPage />
      </Suspense>
    </RoleGuard>
  )
  addTwoColumnRoute('adminDeckbuilder', '/admin/agents/deckbuilder', page)
  addTwoColumnRoute(
    'adminDeckbuilderSession',
    '/admin/agents/deckbuilder/:sessionId',
    page
  )
  // A session on an existing draft deck; the deck's id is the session id.
  addTwoColumnRoute(
    'adminDeckbuilderDeck',
    '/admin/agents/deckbuilder/deck/:slideDeckId',
    page
  )
}
